import * as React from 'react';
import { LoaderProps } from '../../components/loader';

const LoaderView: React.StatelessComponent<LoaderProps> = props => {

    if (!props.isProcessing)
        return null;

    return (
        <div className="ace-loader" role="presentation">
            <div>
                {
                    props.text.loaderImageUrl &&
                    <img className="ace-cal-loading-image" src={props.text.loaderImageUrl} />
                }
                <div></div><div></div><div></div><div></div>
            </div>
        </div>
    )
}

export default LoaderView;